import { mediaSrc } from "../misc/MediaPresets"
import { hugeiconSvg } from "../../../icons/hugeicons"
import type { HugeiconKey } from "../../../icons/hugeicons"

const premiumImageSize = 32

// needs to be synced with
//  - app/models/place.rb
//  - app/frontend/api/places/placeCategories.ts
//  - app/frontend/util/placeCategoryIconMapping.ts
const markerSvgSource = (color: string) => `
  <svg width="29px" height="38px" viewBox="0 0 29 38" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter x="-27.3%" y="-100.0%" width="154.5%" height="300.0%" filterUnits="objectBoundingBox" id="filter-1">
        <feGaussianBlur stdDeviation="1" in="SourceGraphic"></feGaussianBlur>
      </filter>
    </defs>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-1013.000000, -206.000000)">
        <g transform="translate(1015.000000, 208.000000)">
          <ellipse fill-opacity="0.2" fill="#000000" filter="url(#filter-1)" cx="12.5" cy="32.5" rx="5.5" ry="1.5"></ellipse>
          <path d="M16.0122576,25.2793186 C15.9213332,25.458076 15.8340571,25.6423215 15.7499008,25.8325638 C15.5004115,26.3965546 15.2870257,26.9892854 15.0630566,27.710743 C14.9749281,27.994626 14.6332283,29.1583289 14.5447738,29.4372129 C14.0436421,31.0172078 13.5561217,31.75 12.5,31.75 C11.442969,31.75 10.9560197,31.0169773 10.4555818,29.43537 C10.3679426,29.158391 10.0278326,27.9978107 9.93932756,27.7122686 C9.716276,26.9926416 9.50359193,26.4011478 9.25488529,25.8383994 C9.16997702,25.6462775 9.08187428,25.4602801 8.99003222,25.2798838 C3.29099207,23.7188867 -0.75,18.5150337 -0.75,12.5 C-0.75,5.18222707 5.18222707,-0.75 12.5,-0.75 C19.8177729,-0.75 25.75,5.18222707 25.75,12.5 C25.75,18.5143856 21.7098013,23.7180578 16.0122576,25.2793186 Z" stroke="#FFFFFF" stroke-width="1.5" fill="${color}"></path>
            </g>
        </g>
    </g>
</svg>
`

// prettier-ignore
const cluster2Source = (colors: string[]) => `
  <svg width="29px" height="43px" viewBox="0 0 29 43" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <filter x="-27.3%" y="-100.0%" width="154.5%" height="300.0%" filterUnits="objectBoundingBox" id="filter-1">
        <feGaussianBlur stdDeviation="1" in="SourceGraphic"></feGaussianBlur>
      </filter>
    </defs>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-827.000000, -216.000000)">
        <g transform="translate(829.000000, 218.000000)">
          <ellipse fill-opacity="0.2" fill="#000000" filter="url(#filter-1)" cx="12.5" cy="38" rx="5.5" ry="1.5"></ellipse>
          <path d="M16.0122576,25.2793186 C15.9213332,25.458076 15.8340571,25.6423215 15.7499008,25.8325638 C15.5004115,26.3965546 15.2870257,26.9892854 15.0630566,27.710743 C14.9749281,27.994626 14.6332283,29.1583289 14.5447738,29.4372129 C14.0436421,31.0172078 13.5561217,31.75 12.5,31.75 C11.442969,31.75 10.9560197,31.0169773 10.4555818,29.43537 C10.3679426,29.158391 10.0278326,27.9978107 9.93932756,27.7122686 C9.716276,26.9926416 9.50359193,26.4011478 9.25488529,25.8383994 C9.16997702,25.6462775 9.08187428,25.4602801 8.99003222,25.2798838 C3.29099207,23.7188867 -0.75,18.5150337 -0.75,12.5 C-0.75,5.18222707 5.18222707,-0.75 12.5,-0.75 C19.8177729,-0.75 25.75,5.18222707 25.75,12.5 C25.75,18.5143856 21.7098013,23.7180578 16.0122576,25.2793186 Z" stroke="#FFFFFF" stroke-width="1.5" fill="${colors[1] || colors[0]}"></path>
          <path d="M16.0122576,31.2793186 C15.9213332,31.458076 15.8340571,31.6423215 15.7499008,31.8325638 C15.5004115,32.3965546 15.2870257,32.9892854 15.0630566,33.710743 C14.9749281,33.994626 14.6332283,35.1583289 14.5447738,35.4372129 C14.0436421,37.0172078 13.5561217,37.75 12.5,37.75 C11.442969,37.75 10.9560197,37.0169773 10.4555818,35.43537 C10.3679426,35.158391 10.0278326,33.9978107 9.93932756,33.7122686 C9.716276,32.9926416 9.50359193,32.4011478 9.25488529,31.8383994 C9.16997702,31.6462775 9.08187428,31.4602801 8.99003222,31.2798838 C3.29099207,29.7188867 -0.75,24.5150337 -0.75,18.5 C-0.75,11.1822271 5.18222707,5.25 12.5,5.25 C19.8177729,5.25 25.75,11.1822271 25.75,18.5 C25.75,24.5143856 21.7098013,29.7180578 16.0122576,31.2793186 Z" stroke="#FFFFFF" stroke-width="1.5" fill="${colors[0]}"></path>
        </g>
      </g>
    </g>
  </svg>
`;

// prettier-ignore
const cluster3Source = (colors: string[]) => `
  <svg width="29px" height="49px" viewBox="0 0 29 49" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <filter x="-27.3%" y="-100.0%" width="154.5%" height="300.0%" filterUnits="objectBoundingBox" id="filter-1">
        <feGaussianBlur stdDeviation="1" in="SourceGraphic"></feGaussianBlur>
      </filter>
    </defs>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-874.000000, -210.000000)">
        <g transform="translate(876.000000, 212.000000)">
          <ellipse fill-opacity="0.2" fill="#000000" filter="url(#filter-1)" cx="12.5" cy="44" rx="5.5" ry="1.5"></ellipse>
          <path d="M16.0122576,25.2793186 C15.9213332,25.458076 15.8340571,25.6423215 15.7499008,25.8325638 C15.5004115,26.3965546 15.2870257,26.9892854 15.0630566,27.710743 C14.9749281,27.994626 14.6332283,29.1583289 14.5447738,29.4372129 C14.0436421,31.0172078 13.5561217,31.75 12.5,31.75 C11.442969,31.75 10.9560197,31.0169773 10.4555818,29.43537 C10.3679426,29.158391 10.0278326,27.9978107 9.93932756,27.7122686 C9.716276,26.9926416 9.50359193,26.4011478 9.25488529,25.8383994 C9.16997702,25.6462775 9.08187428,25.4602801 8.99003222,25.2798838 C3.29099207,23.7188867 -0.75,18.5150337 -0.75,12.5 C-0.75,5.18222707 5.18222707,-0.75 12.5,-0.75 C19.8177729,-0.75 25.75,5.18222707 25.75,12.5 C25.75,18.5143856 21.7098013,23.7180578 16.0122576,25.2793186 Z" stroke="#FFFFFF" stroke-width="1.5" fill="${colors[2] || colors[1] || colors[0]}"></path>
          <path d="M16.0122576,31.2793186 C15.9213332,31.458076 15.8340571,31.6423215 15.7499008,31.8325638 C15.5004115,32.3965546 15.2870257,32.9892854 15.0630566,33.710743 C14.9749281,33.994626 14.6332283,35.1583289 14.5447738,35.4372129 C14.0436421,37.0172078 13.5561217,37.75 12.5,37.75 C11.442969,37.75 10.9560197,37.0169773 10.4555818,35.43537 C10.3679426,35.158391 10.0278326,33.9978107 9.93932756,33.7122686 C9.716276,32.9926416 9.50359193,32.4011478 9.25488529,31.8383994 C9.16997702,31.6462775 9.08187428,31.4602801 8.99003222,31.2798838 C3.29099207,29.7188867 -0.75,24.5150337 -0.75,18.5 C-0.75,11.1822271 5.18222707,5.25 12.5,5.25 C19.8177729,5.25 25.75,11.1822271 25.75,18.5 C25.75,24.5143856 21.7098013,29.7180578 16.0122576,31.2793186 Z" stroke="#FFFFFF" stroke-width="1.5" fill="${colors[1] || colors[0]}"></path>
          <path d="M16.0122576,37.2793186 C15.9213332,37.458076 15.8340571,37.6423215 15.7499008,37.8325638 C15.5004115,38.3965546 15.2870257,38.9892854 15.0630566,39.710743 C14.9749281,39.994626 14.6332283,41.1583289 14.5447738,41.4372129 C14.0436421,43.0172078 13.5561217,43.75 12.5,43.75 C11.442969,43.75 10.9560197,43.0169773 10.4555818,41.43537 C10.3679426,41.158391 10.0278326,39.9978107 9.93932756,39.7122686 C9.716276,38.9926416 9.50359193,38.4011478 9.25488529,37.8383994 C9.16997702,37.6462775 9.08187428,37.4602801 8.99003222,37.2798838 C3.29099207,35.7188867 -0.75,30.5150337 -0.75,24.5 C-0.75,17.1822271 5.18222707,11.25 12.5,11.25 C19.8177729,11.25 25.75,17.1822271 25.75,24.5 C25.75,30.5143856 21.7098013,35.7180578 16.0122576,37.2793186 Z" stroke="#FFFFFF" stroke-width="1.5" fill="${colors[0]}"></path>
        </g>
      </g>
    </g>
  </svg>
`;

// Trailhead shield marker (34x42px) — amber crest with the Hugeicons hiking icon
const trailheadShieldSource = (color: string) => `
  <svg width="34px" height="42px" viewBox="0 0 34 42" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter id="shield-shadow" x="-20%" y="-10%" width="140%" height="130%">
        <feDropShadow dx="0" dy="1" stdDeviation="1.5" flood-opacity="0.35"/>
      </filter>
    </defs>
    <g filter="url(#shield-shadow)">
      <path d="M17 2 C9 2 3 6 3 12 C3 22 17 39 17 39 C17 39 31 22 31 12 C31 6 25 2 17 2 Z"
        fill="${color}" stroke="#ffffff" stroke-width="2"/>
    </g>
  </svg>
`

const premiumMarkerSource = (color: string) => `
  <svg width="42px" height="53px" viewBox="0 0 42 53" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter x="-27.3%" y="-100.0%" width="154.5%" height="300.0%" filterUnits="objectBoundingBox" id="filter-1">
        <feGaussianBlur stdDeviation="1" in="SourceGraphic"></feGaussianBlur>
      </filter>
    </defs>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-902.000000, -372.000000)">
        <g transform="translate(904.000000, 374.000000)">
          <ellipse fill-opacity="0.2" fill="#000000" filter="url(#filter-1)" cx="19.5" cy="47.5" rx="5.5" ry="1.5"></ellipse>
          <path d="M23.9498105,38.7504836 C23.7879426,38.9868806 23.6346932,39.2173505 23.4889148,39.4439608 C23.2153234,39.8692544 22.9718498,40.3292346 22.7501674,40.8304653 C22.5006282,41.3946809 22.2872088,41.9876513 22.0632271,42.7093655 C21.9750332,42.9935438 21.6333465,44.1576014 21.5449304,44.436465 C21.0438003,46.017025 20.5563014,46.75 19.5,46.75 C18.442969,46.75 17.9560197,46.0169773 17.4555818,44.43537 C17.3679426,44.158391 17.0278326,42.9978107 16.9393276,42.7122686 C16.716276,41.9926416 16.5035919,41.4011478 16.2548853,40.8383994 C16.0335246,40.3375266 15.7903139,39.8779241 15.5169135,39.4530198 C15.3691813,39.2234223 15.2137751,38.9898533 15.0494942,38.7501525 L5,38.75 C1.82436269,38.75 -0.75,36.1756373 -0.75,33 L-0.75,5 C-0.75,1.82436269 1.82436269,-0.75 5,-0.75 L33,-0.75 C36.1756373,-0.75 38.75,1.82436269 38.75,5 L38.75,33 C38.75,36.1756373 36.1756373,38.75 33.0000401,38.75 L23.9498105,38.7504836 Z" id="Combined-Shape-Copy" stroke="#FFFFFF" stroke-width="1.5" fill="${color}"></path>
          <rect fill="#FFFFFF" x="3" y="3" width="32" height="32" rx="3"></rect>
        </g>
      </g>
    </g>
  </svg>
`

const getImageFromSVGSource = (svgSource: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image()

    image.onerror = reject
    image.onload = () => resolve(image)

    const svg = new Blob([svgSource], { type: "image/svg+xml;charset=utf-8" })
    const url = URL.createObjectURL(svg)
    image.src = url
  })

const getPremiumImage = async (publicId?: string): Promise<HTMLImageElement | null> => {
  if (!publicId) {
    return null
  }

  return new Promise(resolve => {
    const image = new Image()

    image.onerror = () => resolve(null)
    image.onload = () => resolve(image)

    image.crossOrigin = "Anonymous"
    image.width = premiumImageSize
    image.height = premiumImageSize

    image.src = mediaSrc({
      publicId: publicId.replace(/(\.jpg)?$/, ".png"),
      dpr: "3.0",
      width: premiumImageSize,
      height: premiumImageSize,
      radius: 3,
    })
  })
}

// Marker icon names to Hugeicons (CVL-70). Place categories use the Hugeicon keys from
// placeCategoryIconMapping.ts. Older names still arrive from saved map settings and cached place
// data: labels from the old map builder's picker (FontAwesome) and the Maki names the
// categories used to have. Any other name draws a plain pin.
const markerIcons: Record<string, HugeiconKey> = {
  restaurant: "restaurant",
  "mask-theater": "mask-theater",
  building: "building",
  bank: "bank",
  bed: "bed",
  store: "store",
  barns: "barns",
  "paint-brush": "paint-brush",
  paintbrush: "paint-brush",
  "building-columns": "bank",
  shop: "store",
  farm: "barns",
  theatre: "mask-theater",
  "town-hall": "bank",
  lodging: "bed",
}

const getIconImage = async (icon?: string): Promise<HTMLImageElement | null> => {
  // Own-property check: a saved name like "constructor" must not hit Object.prototype.
  if (!icon || !Object.prototype.hasOwnProperty.call(markerIcons, icon)) return null
  const svg = hugeiconSvg(markerIcons[icon], { color: "#ffffff", size: 15 })
  return svg ? getImageFromSVGSource(svg) : null
}

const getTrailheadIcon = (): Promise<HTMLImageElement | null> => {
  const svg = hugeiconSvg("hiking", { color: "#ffffff", size: 16 })
  return svg ? getImageFromSVGSource(svg) : Promise.resolve(null)
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getMarker = async ({ width, height, src, publicId, icon }) => {
  const isTrailhead = icon === '__trailhead__'
  const [markerImage, iconImage, premiumImage, trailheadIcon] = await Promise.all([
    getImageFromSVGSource(src),
    isTrailhead ? Promise.resolve(null) : getIconImage(icon),
    getPremiumImage(publicId),
    isTrailhead ? getTrailheadIcon() : Promise.resolve(null),
  ])

  const canvas = document.createElement("canvas")
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext("2d")

  if (ctx && markerImage) {
    ctx.drawImage(markerImage, 0, 0)

    if (trailheadIcon) {
      // Center the hiking icon inside the shield (offset for the pointed bottom)
      ctx.drawImage(trailheadIcon, 9, 8, 16, 16)
    } else if (iconImage) {
      ctx.drawImage(iconImage, 7, 7)
    }

    if (premiumImage) {
      ctx.drawImage(premiumImage, 5, 5, premiumImageSize, premiumImageSize)
    }

    return ctx.getImageData(0, 0, width, height)
  }

  return null
}

// Draw a visible colored pin placeholder using canvas 2D — fully synchronous,
// no async Image loading. This guarantees markers are never invisible.
const getColoredPlaceholder = (width: number, height: number, color: string): ImageData => {
  const canvas = document.createElement("canvas")
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext("2d")
  if (!ctx) return new ImageData(width, height)

  // Draw a pin shape: circle head + pointed tail
  const cx = width / 2
  const r = (width - 6) / 2
  const cy = r + 2 // circle center offset from top

  // Pin body (teardrop)
  ctx.beginPath()
  ctx.arc(cx, cy, r, 0, Math.PI * 2)
  ctx.fillStyle = color
  ctx.fill()

  // Pin tail (triangle pointing down)
  ctx.beginPath()
  ctx.moveTo(cx - r * 0.5, cy + r * 0.7)
  ctx.lineTo(cx, height - 3)
  ctx.lineTo(cx + r * 0.5, cy + r * 0.7)
  ctx.fillStyle = color
  ctx.fill()

  // White border on circle
  ctx.beginPath()
  ctx.arc(cx, cy, r, 0, Math.PI * 2)
  ctx.strokeStyle = "#ffffff"
  ctx.lineWidth = 1.5
  ctx.stroke()

  return ctx.getImageData(0, 0, width, height)
}

// Shield-shaped placeholder for trailhead markers
const getShieldPlaceholder = (width: number, height: number, color: string): ImageData => {
  const canvas = document.createElement("canvas")
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext("2d")
  if (!ctx) return new ImageData(width, height)

  const cx = width / 2

  // Shield body: rounded top that tapers to a point
  ctx.beginPath()
  ctx.moveTo(cx, height - 2)
  ctx.quadraticCurveTo(3, height * 0.55, 3, height * 0.3)
  ctx.quadraticCurveTo(3, 3, cx, 3)
  ctx.quadraticCurveTo(width - 3, 3, width - 3, height * 0.3)
  ctx.quadraticCurveTo(width - 3, height * 0.55, cx, height - 2)
  ctx.fillStyle = color
  ctx.fill()

  ctx.strokeStyle = "#ffffff"
  ctx.lineWidth = 1.5
  ctx.stroke()

  return ctx.getImageData(0, 0, width, height)
}

interface MarkerData {
  height: number
  width: number
  src: string
  color: string
  icon?: string
  publicId?: string
}

const parseMarkerData = (name: string): MarkerData => {
  // Trailhead shield marker: trailhead-marker_{#hex}
  const trailheadMatch = name.match(/^trailhead-marker_(#[0-9a-fA-F]{6})$/)
  if (trailheadMatch) {
    const [, color] = trailheadMatch
    return { width: 34, height: 42, src: trailheadShieldSource(color), color, icon: '__trailhead__' }
  }

  // Premium markers: premium-marker_{#hex}_{publicId}
  // Use regex so underscores inside Cloudinary publicIds don't break parsing
  const premiumMatch = name.match(/^premium-marker_(#[0-9a-fA-F]{6})_(.+)$/)
  if (premiumMatch) {
    const [, color, publicId] = premiumMatch
    return { width: 42, height: 53, src: premiumMarkerSource(color), color, publicId }
  }

  // Regular and cluster markers: marker_{icon}_{#color}
  const markerMatch = name.match(/^marker_(.*?)_(#[0-9a-fA-F]{6})$/)
  if (markerMatch) {
    const [, icon, color] = markerMatch
    switch (icon) {
      case "cluster2":
        return { width: 29, height: 43, src: cluster2Source([color]), color }
      case "cluster3":
        return { width: 29, height: 49, src: cluster3Source([color]), color }
      default:
        return { width: 29, height: 38, src: markerSvgSource(color), color, icon }
    }
  }

  throw new Error(`Could not generate image for ${name}`)
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const addMissingMarker = ({ map, name }) => {
  try {
    const { width, height, src, color, icon, publicId } = parseMarkerData(name)

    // Add a VISIBLE colored pin placeholder synchronously (canvas 2D, no async Image load).
    // This guarantees markers are never invisible — Mapbox renders this immediately.
    const isTrailhead = icon === '__trailhead__'
    const placeholder = isTrailhead
      ? getShieldPlaceholder(width, height, color)
      : getColoredPlaceholder(width, height, color)
    map.addImage(name, placeholder)

    // Load the full detailed marker (SVG pin + icon overlay + premium image) async,
    // then swap it in when ready. The swap is removeImage + addImage, not updateImage:
    // with Mapbox GL 3.x, pins already drawn from an image swapped by updateImage vanish
    // or stay as the placeholder once you zoom in (CVL-88). Fire a custom event so
    // layers using this image can call setData() to rebuild symbol bucket vertex buffers.
    getMarker({ width, height, icon, publicId, src }).then(fullImage => {
      // Skip if the style was reloaded or the image removed while the drawing loaded.
      if (fullImage && map.hasImage(name)) {
        map.removeImage(name)
        map.addImage(name, fullImage)
        map.triggerRepaint()
        map.fire('markerImageUpdated', { name })
      }
    })
  } catch (error) {
    console.error(error.message)
  }
}
